import { render, staticRenderFns } from "./OrgChartFilter.vue?vue&type=template&id=bbafe346"
import script from "./OrgChartFilter.vue?vue&type=script&lang=js"
export * from "./OrgChartFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports